/* eslint-disable no-restricted-imports */
import * as remix from "@remix-run/react";
import type { Ref } from "react";
import * as router from "react-router-dom";

import { useShouldFrontendRefresh } from "@shared/data/client/links/getShouldFrontendRefreshLink/shouldFrontendRefresh.store";
import { isRemix } from "@shared/utils/fullscriptEnv/fullscriptEnv";

type LinkProps = router.LinkProps &
  remix.LinkProps & {
    ref?: Ref<HTMLAnchorElement>;
  };

/**
 * A Link component wrapping Link from Remix and react-router-dom
 * It can be used in interchangeably in a Remix or react-router-dom based SPA and work as expected
 * Means that devs don't need to worry about where an app is running and what API to use
 */
const Link = (props: LinkProps) => {
  const shouldFrontendRefresh = useShouldFrontendRefresh();

  if (isRemix()) {
    return <remix.Link reloadDocument={shouldFrontendRefresh} {...props} />;
  }

  return <router.Link reloadDocument={shouldFrontendRefresh} {...props} />;
};

export { Link, type LinkProps };
